import de from '../assets/images/logos/magazine-logo-de.svg';
import en from '../assets/images/logos/magazine-logo-en.svg';
import es from '../assets/images/logos/magazine-logo-es.svg';
import it from '../assets/images/logos/magazine-logo-it.svg';
import pl from '../assets/images/logos/magazine-logo-pl.svg';
import pt from '../assets/images/logos/magazine-logo-pt.svg';

const fr = en;
const sv = en;

export default {
  de,
  en,
  es,
  fr,
  it,
  pl,
  pt,
  sv,
};
